import React from 'react';
import styled from 'styled-components';
import SideBar from './components/SideBar';
import { Link } from 'react-router-dom';
import styles from './About.module.scss'
import mumrecord from './mumrecord.png';
import { FaPlay } from 'react-icons/fa';
import { FaBars } from 'react-icons/fa';
import { GrClose } from 'react-icons/gr'
import { FaTwitter, FaInstagram, FaLinkedin } from 'react-icons/fa';
import { GrInstagram } from 'react-icons/gr';
import { motion } from "framer-motion"


import ListGroup from 'react-bootstrap/ListGroup'
import Alert from 'react-bootstrap/Alert'
import Accordion from 'react-bootstrap/Accordion'

const products = {
  initial: { y: -20, opacity: 0 },
  animate: {
    y: 0,
    opacity: 1,
    transition: {
      duration: 0.7,
      ease: [0.6, -0.05, 0.01, 0.99],
    },
  },
};

export const About = () => (
  <motion.div exit={{ opacity: 0 }}>
        <motion.section
            variants={products}
            className="text-gray-700 body-font"
          >
    <div className={styles.container}>
    </div>
    <div className={styles.mumrecordcontainer}>
    <img sm={12} md={6} lg={4}className={styles.mumrecrd} src={mumrecord}></img>
    </div>
    <div className={styles.container}>
      <h1 className={styles.header}></h1>
      <div className={styles.info}>
        Susanna Byrne lives and works in London. Since graduating from Goldsmiths College in 2009 Susanna has participated in group shows by curatorial collectives Circuit Wisely and Silent City.
      </div>
      <div className={styles.info}>
        Susanna's written contributions for Silent City appeared in Art as Activism in collaboration with Shoppinghour and this is tomorrow.
      </div>
      <div className={styles.info}>
        Susanna is also a founding trustee of artist-led non-profit organisation X presents.
      </div>
      <h2 className={styles.education}>education</h2>
      <div className={styles.containers}>
        <d1>BA Fine Art & History of Art</d1>
        <d2>Goldsmiths University of London</d2>
        <d3>Goldsmiths University of London</d3>
        <d4>City Lit London</d4>
      </div>
    </div>
    </motion.section>
  </motion.div>

)

